import $ from "jquery";

function Navbar(){
    // selectors
    var navbar = $('.navbar');
    var navbarButton = navbar.find('.secondary-btn');
    // var underligned = navbar.find('.underligned');
    // var active = navbar.find('.active');
    // var navbarLi = navbar.find('.left').find('li').children('a');
    var logo = navbar.find('.logo');
    var middle = navbar.find('.middle');

    
    // events
    // setTimeout(positionUnderligned, 200);
    // navbarLi.on('mouseover', changePositionUnderligned);
    // navbarLi.on( "mouseenter", changePositionUnderligned).on( "mouseleave", positionUnderligned );
    $(document).on('scroll', changeNavbarSkin);
    

    //methods
    function changeNavbarSkin(){
        // console.log($(window).scrollTop());
        if(!navbar.hasClass('default')){
            if($(window).scrollTop() > 0){
                if(navbar.hasClass('transparent')){
                    navbar.removeClass('transparent');
                    navbarButton.removeClass('secondary-btn__white').addClass('secondary-btn__black');
                    // underligned.css('background-color', 'black');
                    logo.find('path').css('fill', 'black');
                    middle.css('animation', 'show .2s');
                }
            }else{
                if(!navbar.hasClass('transparent')){
                    navbar.addClass('transparent');
                    navbarButton.removeClass('secondary-btn__black').addClass('secondary-btn__white');
                    // underligned.css('background-color', 'white');
                    logo.find('path').css('fill', 'white');
                    middle.css('animation', 'hide .2s');
                }
            }
        }
    }

    // function positionUnderligned(){
    //     var positionOfLine = active.offset().left;
    //     var widthOfLine = active.width();
    //     // console.log(active);
    //     // console.log(active.offsetWidth);
    //     underligned.css({
    //         'left': positionOfLine,
    //         'width': widthOfLine + 'px'
    //     });

    // }

    // function changePositionUnderligned(){
    //     var positionOfLine = $(this).offset().left;
    //     var widthOfLine = $(this).width();
    //     // console.log(active);
    //     // console.log(active.offsetWidth);
    //     underligned.css({
    //         'left': positionOfLine,
    //         'width': widthOfLine + 'px'
    //     });
    // }
}

export default Navbar;